import React, { useEffect, useState } from 'react';
import {
    Button,
    Checkbox,
    CircularProgress,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Typography
} from '@material-ui/core';
import StorefrontIcon from '@material-ui/icons/Storefront';
import { getMerchants } from '../api';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import InfoCard from './InfoCard';

const Merchant = ({
    market,
    selectedMerchants,
    merchantCount,
    setMerchantCount,
    setSelectedMerchants
}) => {
    const [merchants, setMerchants] = useState([]);
    const [loading, setLoading] = useState(true);

    const getData = () => {
        getMerchants(market.id)
            .then(
                res =>
                    setMerchants(res.data) ||
                    setMerchantCount(res.count) ||
                    (selectedMerchants.length === 0 && setSelectedMerchants(res.data))
            )
            .catch(err => alert(err))
            .finally(() => setLoading(false));
    };

    const isSelected = merchant => {
        return selectedMerchants.find(s => s.id === merchant.id) !== undefined;
    };

    useEffect(() => {
        if (loading) {
            getData();
        }
    }, [loading]);

    return (
        <Grid
            container
            direction="row"
            alignContent="center"
            justify="center"
            justifyContent="center"
            alignItems="center"
            spacing={2}>
            <Grid item xs={12}>
                <InfoCard
                    market={market}
                    merchants={selectedMerchants}
                    merchantCount={merchantCount}
                />
            </Grid>
            {loading ? (
                <CircularProgress size={35} style={{ margin: 20 }} />
            ) : (
                <>
                    <Grid item xs={12}>
                        <Grid container direction="row" spacing={2}>
                            <Grid item xs={6}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    fullWidth
                                    color="primary"
                                    onClick={() => setSelectedMerchants(merchants)}>
                                    Tout sélectionner
                                </Button>
                            </Grid>
                            <Grid item xs={6}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    fullWidth
                                    color="secondary"
                                    onClick={() => setSelectedMerchants([])}>
                                    Tout desélectionner
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <List dense>
                            {merchants.map(merchant => (
                                <ListItem
                                    key={merchant.id}
                                    button
                                    divider
                                    dense
                                    onClick={() => setSelectedMerchants(merchant)}>
                                    <ListItemAvatar style={{ minWidth: 40 }}>
                                        {isSelected(merchant) ? (
                                            <AccountCircleIcon
                                                color={isSelected(merchant) ? 'primary' : 'inherit'}
                                            />
                                        ) : (
                                            <AccountCircleOutlinedIcon
                                                color={isSelected(merchant) ? 'primary' : 'inherit'}
                                            />
                                        )}
                                    </ListItemAvatar>
                                    <ListItemText
                                        id={merchant.id}
                                        primary={
                                            <Typography variant="body1">
                                                {merchant.raisonSociale}{' '}
                                                {merchant.abonnement ? (
                                                    <span
                                                        style={{ fontSize: 10, color: '#546f7a' }}>
                                                        {' '}
                                                        - abonné
                                                    </span>
                                                ) : null}
                                            </Typography>
                                        }
                                        secondary={
                                            <Grid
                                                container
                                                direction="row"
                                                alignContent="flex-end"
                                                alignItems="flex-end">
                                                <Grid item>
                                                    <StorefrontIcon
                                                        style={{
                                                            fontSize: 12,
                                                            marginBottom: -2,
                                                            marginRight: 2
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <Typography variant="body2">
                                                        Place {merchant.sector}
                                                        {merchant.numeroPlace} / {merchant.metres}{' '}
                                                        mètres {merchant.water ? ' / Eau' : null}
                                                        {merchant.electricity
                                                            ? ' / Electricité'
                                                            : null}
                                                        {merchant.vehicule ? ' / Véhicule' : null}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        }
                                    />
                                    <ListItemSecondaryAction>
                                        <Checkbox
                                            edge="end"
                                            onChange={() => setSelectedMerchants(merchant)}
                                            checked={isSelected(merchant)}
                                            inputProps={{ 'aria-labelledby': merchant.id }}
                                        />
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                </>
            )}
        </Grid>
    );
};

export default Merchant;
